module.exports = __webpack_public_path__ + "static/media/datenight.ff91df7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Calculator/icons/datenight.png
// module id = 557
// module chunks = 0